import { Image as ImageIcon } from "lucide-react";
import { SubBadge } from "@/components/admin/SectionShell";
import { resolveImg } from "@/lib/media";
import { SectionCard } from "../SectionShell";
import { inputCls, TextField, ToggleRow } from "./Fields";

const ANN_TOGGLES = [
  ["ann_banner_visible", "Announcement banner text"],
  ["ann_notice_visible", "Big scrolling notice"],
  ["ann_zoom_visible", "Common Zoom Link block"],
  ["ann_batch_visible", "New Batch block"],
  ["ann_sharings_visible", "Experience Sharings block"],
  ["ann_details_visible", "Program Details box (Language / Mode / Contact / Email)"],
];

export const AnnouncementSection = ({ content, setC, annUploading, uploadAnnImage }) => (
  <SectionCard id="announcement" testId="section-announcement">
    <ToggleRow testId="content-announcement-visible" label="Announcement / Zoom section" sub="Master switch for the whole announcement box on the main page" checked={content.announcement_visible !== false} onChange={(v) => setC("announcement_visible", v)} className="mb-5" />
    <div className="grid md:grid-cols-2 gap-5">
      <TextField k="ann_banner" label="Announcement banner (auto-written from Master Control on each Publish while Auto-sync is on)" content={content} setC={setC} span />
      <TextField k="ann_notice" label="Big scrolling notice (empty = hidden · auto-written on Publish while Auto-sync is on)" content={content} setC={setC} span />
      <div className="md:col-span-2">
        <label className="text-xs uppercase tracking-widest text-muted-foreground">Announcement banner image</label>
        <div className="flex flex-wrap gap-3 items-center mt-2">
          <img src={resolveImg(content.ann_image)} alt="" className="w-24 h-14 rounded-lg object-cover border border-border bg-muted" />
          <input data-testid="content-ann_image" value={content.ann_image || ""} onChange={(e) => setC("ann_image", e.target.value)} placeholder="Paste image URL or upload →"
            className={`flex-1 min-w-[200px] ${inputCls} mt-0 text-sm`} />
          <label data-testid="content-ann-upload-label" className={`inline-flex items-center gap-2 rounded-full border border-accent text-accent px-4 py-2.5 text-sm cursor-pointer hover:bg-accent hover:text-white transition-colors ${annUploading ? "opacity-60 pointer-events-none" : ""}`}>
            <ImageIcon size={15} /> {annUploading ? "Uploading…" : "Upload"}
            <input type="file" accept="image/*" data-testid="content-ann-upload" className="hidden" onChange={(e) => uploadAnnImage(e.target.files?.[0])} />
          </label>
        </div>
      </div>
      <TextField k="training_line" label="Training line (e.g. 6 Days Training)" content={content} setC={setC} span />
      <TextField k="zoom_link" label="Zoom join link" content={content} setC={setC} span />
      <TextField k="zoom_meeting_id" label="Zoom Meeting ID" content={content} setC={setC} />
      <TextField k="zoom_passcode" label="Zoom Passcode" content={content} setC={setC} />
      <TextField k="batch_dates" label="New batch dates" content={content} setC={setC} />
      <TextField k="batch_time" label="Batch timings" content={content} setC={setC} />
      <TextField k="exp_when" label="Experience sharings (when)" content={content} setC={setC} span />
      <TextField k="language_line" label="Language" content={content} setC={setC} />
      <TextField k="mode_line" label="Mode" content={content} setC={setC} />
      <TextField k="contact_numbers" label="Contact numbers (WhatsApp)" content={content} setC={setC} span />
    </div>
    <div className="mt-6 rounded-2xl border border-white/80 bg-white/40 p-5" data-testid="announcement-visibility-panel">
      <h3 className="text-sm font-semibold uppercase tracking-widest text-muted-foreground mb-4"><SubBadge /> Announcement items — show / hide</h3>
      <div className="grid sm:grid-cols-2 gap-3">
        {ANN_TOGGLES.map(([k, label]) => (
          <ToggleRow key={k} testId={`content-${k}`} label={label} checked={content[k] !== false} onChange={(v) => setC(k, v)} />
        ))}
      </div>
    </div>
  </SectionCard>
);
